import React, {useEffect, useState} from 'react'
import {Rect} from "react-konva";
import useImage from "use-image";

const BackgroundProductImage = ({
                                    productImage,
                                }) => {
    const [image] = useImage(productImage.url, 'anonymous');
    const shapeRef = React.useRef();

    return (
        <>
            {image &&
                <Rect
                    name={'product-image'}
                    ref={shapeRef}
                    fillPatternImage={image}
                    fillPatternRepeat={'no-repeat'}
                    {...productImage?.props}
                    listening={false}/>
            }
        </>
    )
}

export default BackgroundProductImage
